import React from "react";
import { useAuth } from "../../../contexts/AuthProvider";
import { LoadState } from "../../../constants/enums";
import { useDispatchWrapper } from "../../../hooks";
import { api } from "../../../api/api";
import { showMessage } from "../../../redux/messages/messagesActions";
import { LinearProgress } from "@mui/material";
import { useBillingCompanyContext } from "../../../providers";

interface ICompanyWalletContext {
  remainingBalance: string | null;
  status: string | null;
}

export const CompanyWalletContext = React.createContext<ICompanyWalletContext>({
  remainingBalance: "",
  status: "",
});

export const useCompanyWallet = () => React.useContext(CompanyWalletContext);

export const CompanyWalletProvider: React.FC<{ children: React.ReactNode }> = (
  props,
) => {
  const { user, isLogin } = useAuth();

  const [remainingBalance, setRemainingBalance] = React.useState<string | null>(
    null,
  );
  const [status, setStatus] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState<LoadState>(LoadState.NotLoaded);

  const dispatch = useDispatchWrapper();

  const company = useBillingCompanyContext();

  const fetchCompanyWalletInfo = async () => {
    try {
      setLoading(LoadState.InProgress);

      const response = await api.get(
        `/wallet/get-company-outlet-wallet?company_outlet_uuid=${company.comapny.company_outlet_uuid}`,
      );

      const walletData = response?.data?.data || [];

      if (walletData.length > 0) {
        setRemainingBalance(walletData[0].remaining_balance);
        setStatus(walletData[0].status);
      } else {
        setRemainingBalance(null);
        setStatus(null);
      }

      setLoading(LoadState.Loaded); // ✅ ALWAYS SET THIS
    } catch (err: any) {
      setLoading(LoadState.Failed);

      // dispatch(
      //   showMessage({
      //     type: "error",
      //     message: err?.response?.data?.message,
      //     displayAs: "snackbar",
      //   }),
      // );
    }
  };

  React.useEffect(() => {
    if (isLogin && company?.comapny?.company_outlet_uuid) {
      fetchCompanyWalletInfo();
    }
  }, [isLogin, company?.comapny?.company_outlet_uuid]);

  if (!isLogin) {
    return <>{props.children}</>;
  }

  return (
    <CompanyWalletContext.Provider
      value={{
        remainingBalance,
        status,
      }}
    >
      {props.children}
    </CompanyWalletContext.Provider>
  );
};
